// extracted by mini-css-extract-plugin
export default {"main":"styles_main__o6Wia","message":"styles_message__n0SkL","warning":"styles_warning__vZl3A"};